export default function(ctx) {
var __t, __p = '';
__p += '<div ref="mapContainer" id="' +
((__t = (ctx.instance.id)) == null ? '' : __t) +
'-map" class="' +
((__t = (ctx.ofPrefix)) == null ? '' : __t) +
'leaflet-map"></div>\n';
return __p
}